module.exports = __webpack_public_path__ + "img/pnu_read_thumbnail.815c988e.jpg";